import * as Sentry from '@sentry/react';
import { createBrowserRouter, Navigate } from 'react-router';

import {
  BookingLayout,
  SelectDateTime,
  SelectTreatment,
  PaymentSummary,
  BankTransferPayment,
  CreditCardPayment,
  AlipayPayment,
  ThankYou,
  SplashPage,
  ProfileLayout,
  PhoneNumberInputPage,
  OTPVerificationPage,
  ProfileHomePage,
  ProfileSettingsPage,
} from '@/pages';
import { BookingService, isLiffInClient } from '@/services';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const rootElement = isLiffInClient() ? null : (
  <Navigate to="/booking" replace />
);

const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: rootElement,
  },
  {
    path: '/booking',
    element: <BookingLayout />,
    children: [
      {
        index: true,
        element: <SelectDateTime />,
      },
      {
        path: 'select-date-time',
        element: <SelectDateTime />,
      },
      {
        path: 'select-treatment',
        element: <SelectTreatment />,
      },
      {
        path: 'summary',
        element: <PaymentSummary />,
        loader: async () => {
          try {
            const therapists = await BookingService.getTherapists();
            return { therapists };
          } catch (error) {
            console.error('Failed to load therapists:', error);
            return { therapists: [] };
          }
        },
      },
    ],
  },
  {
    path: '/profile',
    element: <ProfileLayout />,
    children: [
      {
        index: true,
        element: <SplashPage />,
      },
      {
        path: 'phone',
        element: <PhoneNumberInputPage />,
      },
      {
        path: 'otp',
        element: <OTPVerificationPage />,
      },
      {
        path: 'home',
        element: <ProfileHomePage />,
      },
      {
        path: 'settings',
        element: <ProfileSettingsPage />,
      },
    ],
  },
  {
    path: '/booking/payment/bank-transfer',
    element: <BankTransferPayment />,
  },
  {
    path: '/booking/payment/credit-card',
    element: <CreditCardPayment />,
  },
  {
    path: '/booking/payment/alipay',
    element: <AlipayPayment />,
  },
  {
    path: '/booking/thank-you',
    element: <ThankYou />,
  },
]);

export default router;
